import { observer } from 'mobx-react';
import useAsyncEffect from 'use-async-effect';
import { useNavigate, } from 'react-router-dom';
import SpcViewModel from './SpcViewModel';
import { Appl } from '../../../../core/Appl';
const SpcInitApp = observer(() => {
  const vm = Appl.Services.get<SpcViewModel>('SpcViewModel');
  vm.navigate = useNavigate();

  useAsyncEffect(async () => {
    await vm.validateAndVerifyUrl(document.location.href);
  }, []);

  return (
    <>
      <div className="space-y-6 max-w-full">
        
      </div>
    </>
  );
});

export default SpcInitApp;
